import React from 'react';

import NavActions from 'lib/NavActions';
import { NavigationConstants } from 'lib/Constants';

import footerLogo from '../../assets/images/cooper-vision-logo-mobile.webp';
import FooterStyles from './_FooterStyles.module.scss';

const Footer = (): JSX.Element => {
    const {
        navToCooperCompanies, navToTermsAndConditions, navToHomeFAQSection, navToProducts, navToLogin, navToHomeHowToJoinSection,
    } = NavActions;

    const {
        cooperCompaniesPage,
    } = NavigationConstants;

    return (
        <footer className={FooterStyles.container}>
            <div className={FooterStyles.box}>
                <img alt='CooperVision' src={footerLogo} className={FooterStyles.container__logo} />
                <button
                    type='button'
                    className={FooterStyles.button}
                    aria-label='Back to top'
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                />
                <div className={FooterStyles.content}>
                    <div className={FooterStyles.navigation}>
                        <a
                            onClick={(e) => {
                                e.preventDefault();
                                navToHomeHowToJoinSection();
                            }}
                            href={cooperCompaniesPage}
                        >
                            How to Join
                        </a>
                        <a
                            onClick={(e) => {
                                e.preventDefault();
                                navToHomeFAQSection();
                            }}
                            href={cooperCompaniesPage}
                        >
                            FAQ
                        </a>
                        <a
                            onClick={(e) => {
                                e.preventDefault();
                                navToProducts();
                            }}
                            href={cooperCompaniesPage}
                        >
                            Products
                        </a>
                        <a
                            onClick={(e) => {
                                e.preventDefault();
                                navToTermsAndConditions();
                            }}
                            href={cooperCompaniesPage}
                        >
                            Terms & Conditions
                        </a>
                        <a
                            onClick={(e) => {
                                e.preventDefault();
                                navToLogin();
                            }}
                            href={cooperCompaniesPage}
                        >
                            Login/Sign Up
                        </a>
                    </div>
                    <div className={FooterStyles['contact-us']}>
                        <h4>Contact Us</h4>
                        <h4>CooperVision Singapore</h4>
                        <p>info@sg.coopervision.com</p>
                        <h4>CooperVision Asia Pacific</h4>
                        <p>
                            One Temasek Avenue, #39-01,
                            <br />
                            Milenia Tower
                            <br />
                            Singapore 039192
                        </p>
                    </div>
                </div>
                <div className={FooterStyles['copyright-container']}>
                    © 2026 CooperVision® |
                    {' \u00A0'}
                    Part of

                    {' '}

                    <a
                        onClick={(e) => {
                            e.preventDefault();
                            navToCooperCompanies();
                        }}
                        href={cooperCompaniesPage}
                    >
                        CooperCompanies
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
